module.exports = __webpack_public_path__ + "img/feature_3.5c9d60a0.png";